export function VideoPlayCircleIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      aria-hidden="true"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.91 11.672a.375.375 0 0 1 0 .656l-5.603 3.113a.375.375 0 0 1-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112Z"
      />
    </svg>
  );
}

export function EngagementIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="#D0D5DD"
        d="M20.25 13.81v.19a8.25 8.25 0 1 1-9.62-8.154 3 3 0 1 0 4.278 3.838 3 3 0 0 0 4.278 3.838a8.307 8.307 0 0 1 1.064.288Z"
      />
      <path
        fill="#667085"
        d="M13.5 6a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0ZM18 7.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
      />
    </svg>
  );
}

export function ImpactIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      {...props}
    >
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4.5v2l-3-3 3-3v2H17v2zm-6.5-6v2L7 11l3.5 3v-2H7v-2h3.5z" />
    </svg>
  );
}

export function RapidGrowthIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      {...props}
    >
      <path d="M19.418 8.204a.75.75 0 1 0-1.06-1.06l-8.204 8.203V9.75a.75.75 0 0 0-1.5 0v6.75c0 .414.336.75.75.75h6.75a.75.75 0 0 0 0-1.5H9.942l8.203-8.204Z" />
    </svg>
  );
}

// i think these icons look more like the ones we have on the the figma design system, .
export function RapidGrowthIcon2() {
  return (
    <svg
      className="w-10 h-10 text-red-600"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path d="M3 17h2v-3h2v3h2v-6h2v6h2v-4h2v4h2v-8h2v8h2v-10h2v10h2v2H3z" />
    </svg>
  );
}

export function EngagementIcon2() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      width="40"
      height="40"
    >
      <g
        fill="none"
        stroke="#D32F2F"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path
          d="M20 10c-7 0-12 5-12 11.5S13 33 20 33h1l2 5 4-5h4c7 0 12-5 12-11.5S34 10 27 10H20z"
          fill="#FAF4EB"
        />
        <line
          x1="22"
          y1="17"
          x2="30"
          y2="17"
          stroke="#D32F2F"
          strokeWidth="2"
        />
        <line
          x1="22"
          y1="22"
          x2="28"
          y2="22"
          stroke="#D32F2F"
          strokeWidth="2"
        />
      </g>
      <g transform="translate(20, 20)">
        <path
          d="M20 10c-5 0-9 4-9 9 0 4 3 7 6 9l3 4 3-4c3-2 6-5 6-9 0-5-4-9-9-9z"
          fill="#FAF4EB"
          stroke="#D32F2F"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17 18c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.4-2.2 3-3 3s-3-1.6-3-3z"
          fill="#D32F2F"
        />
      </g>
    </svg>
  );
}

export function ImpactIcon2() {
  return (
    <svg
      className="w-10 h-10 text-white bg-red-600 rounded-full p-2"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17 1v6h-6M7 23v-6h6M3.51 9a9 9 0 0 1 14.13-3.36M20.49 15a9 9 0 0 1-14.13 3.36"
      />
    </svg>
  );
}
